import { useComplexQuery } from '@sequencehq/api'
import { useMemo } from 'react'
import { allIds } from '../utils'
import { useBulkActions } from './useBulkActions'
import { BulkActionEntityConfig, BulkActionType } from '../types'

export const useEnrichedBulkActions = <TEntity>(props: {
  refetchInterval?: number
  types: BulkActionType[]
  /**
   * How to resolve bulk-action ids to display entities. Omit to skip
   * enrichment entirely (counts-only consumers).
   */
  enrich?: BulkActionEntityConfig<TEntity>['enrich']
}) => {
  const { bulkActions, isLoading: bulkActionsLoading } = useBulkActions({
    refetchInterval: props.refetchInterval,
    types: props.types
  })

  const ids = useMemo(
    () => Array.from(new Set(bulkActions.flatMap(allIds))),
    [bulkActions]
  )

  const { enrich } = props
  const enrichment = useComplexQuery({
    queryKey: [
      enrich?.cacheKey ?? 'bulkActions.noEnrichment',
      'CUSTOM:useEnrichedBulkActions',
      JSON.stringify(ids)
    ],
    queryFn: async () => (enrich ? enrich.fetch(ids) : {})
  })

  return {
    isLoading: bulkActionsLoading,
    bulkActions,
    entities: (enrichment.data ?? {}) as Record<string, TEntity>
  }
}
